import { render } from "./agriculture.vue?vue&type=template&id=0ebf8b4c&scoped=true"
const script = {}

import "./agriculture.vue?vue&type=style&index=0&id=0ebf8b4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ebf8b4c"]])

export default __exports__